import { Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { routerTransition } from '../../router.animations';
import { Router } from '@angular/router';
import { UserService } from '../../shared/services/user/user.service';
import { ToastrService } from 'ngx-toastr';
import { FormArray, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { CustomValidators } from "../../reset-password/custom-validators";
import { debounceTime, switchMap } from 'rxjs/operators';
import { Subject, BehaviorSubject } from 'rxjs';
declare var $: any;

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    animations: [routerTransition()]
})
export class HomeComponent implements OnInit, OnDestroy {
    public alerts: Array<any> = [];
    public sliders: Array<any> = [];
    token = localStorage.getItem('token');
    person: any;
    additionalData: any;
    incomplete = 'Incomplete';
    employeeDetails: any;
    messageserviceList: any;
    assistantTrainerList: any;
    authorisedRepresentativeList: any;
    today: number = Date.now();
    link: any;
    id: any;
    status: any;
    editing = true;
    loading = false;
    submitted = false;
    under18Age: any;
    duplicationDescription: any;
    formLink: any;
    imageLink: any;
    userAssignList: any;
    notificationForm: FormGroup;
    employeeForm: FormGroup;
    userDetailsForm: FormGroup;
    userDetails: any;
    userDetailsForEdit: any;
    userFileDetails: any;
    userLicenceDetails: any;
    userReferenceRequestDetails: any;
    userEquinePremisesNumberRequestDetails: any;
    licensingApplicationDetails: any;
    jockeyAgentApplicationDetails: any;
    jockeyValetApplicationDetails: any;
    applicantDetails: any;
    feesReuestList: any;
    summaryFileUpload: any;
    medicalQuestionsData: any;
    principalYardData: any;
    additionalYardData: any;
    prospectiveOwners: any;
    sbsAgreement: any;
    requestType: any;
    table: any;
    taskStatus: any;
    showApplicantUserDetails: any;
    showGeneralUserDetails: any;
    requestMedicalQuestionnaire = false;
    claimOrAssignForm: FormGroup;
    applicationPersonList: any;
    personFeesList: any;
    applicationPersonForm: FormGroup;
    personFeesForm: FormGroup;
    applicationAssignForm: FormGroup;
    idForCommitteeReport: any;
    checkForCommitteeReport: any;
    committeeMeetingReviewDataSuccessMessage: any;
    applicationIdForProceedIssueLicence: any;
    proceedIssueLicenceDataSuccessMessage: any;
    config: any;
    page = 1;
    perPage = 10;
    key: string = 'licensingApplicationSubmittedDate';
    reverse = false;
    direction: string = 'DESC';
    filterLetter: string = '';
    summaryStatus: string = '';
    licenceTypeStatusForApplicationTask: string = 'ALL';
    generalTasksData: any;
    generalTasksForm: FormGroup;
    config2: any;
    page2 = 1;
    perPage2 = 10;
    key2: string = 'createdDate';
    reverse2 = true;
    direction2: string = 'DESC';
    filterLetter2: string = '';
    licenceTypeStatusForGeneralTask: string = 'ALL';
    applicantStatusForGeneralTask: string = "Pending";
    applicationRequestList: any;
    applicationRequestForm: FormGroup;
    config3: any;
    page3 = 1;
    perPage3 = 10;
    key3: string = 'createdDate';
    reverse3 = false;
    direction3: string = 'DESC';
    filterLetter3: string = '';
    personId: any;
    applicationId: any;

    generalPersonTaskList: any;
    generalPersonTaskForm: FormGroup;
    config4: any;
    page4 = 1;
    perPage4 = 10;
    key4: string = 'createdDate';
    reverse4 = false;
    direction4: string = 'DESC';
    filterLetter4: string = '';
    generalPersonId: any;
    generalPersonStatus: string = 'ALL';

    otherTaskList: any;
    otherTaskForm: FormGroup;
    config6: any;
    page6 = 1;
    perPage6 = 10;
    key6: string = 'createdDate';
    reverse6 = false;
    direction6: string = 'DESC';
    filterLetter6: string = '';
    futureDevelopmentData: any;

    personListSearch = new Subject<string>();
    personListSearch2 = new Subject<string>();
    personListSearch3 = new Subject<string>();
    personListSearch4 = new Subject<string>();
    personListSearch5 = new Subject<string>();

    waitingOnOtherTaskList: any;
    config7: any;
    page7 = 1;
    perPage7 = 10;
    key7: string = 'createdDate';
    reverse7 = true;
    direction7: string = 'DESC';
    filterLetter7: string = '';

    suspendAccountForm: FormGroup;
    isSuspendAccount = false;

    personListData: any;
    suspendAccountListForm: FormGroup;
    applicationTabFormGroup: FormGroup;
    config8: any;
    page8 = 1;
    perPage8 = 10;
    key8: string = 'createdDate';
    reverse8 = false;
    direction8: string = 'DESC';
    filterLetter8: string = '';

    emergencyLicenceDetailsData: any;
    public isRenewalApplication: boolean = false;
    public editTabForm: boolean = false;
    public trainerList: Array<{ trainerId: string, trainerName: string }> = [];
    public trainerFormGroup: FormGroup;
    public trainerDetails: any;
    concussionDate: any;

    zero: any;
    one: any;
    two: any;
    three: any;
    four: any;
    five: any;
    six: any;
    seven: any;
    eight: any;
    nine: any;
    ten: any;
    eleven: any;
    twelve: any;
    thirteen: any;
    fourteen: any;
    fifteen: any;
    selectLicenceFeesForLicensingApplication: any;
    selectLicenceFeesForLicensingApplicationForm: FormGroup;
    licenceFeesListForm: FormGroup;
    isEdit: boolean = true;
    applicationFeesList: any;
    isApplicationTaskLoading = false;
    isGeneralTaskLoading = false;
    isOtherTaskLoading = false;
    isWaitingOnOtherTaskLoading = false;
    constructor(private router: Router,
        private formBuilder: FormBuilder,
        private toastr: ToastrService,
        private userService: UserService,
        private elementRef: ElementRef,
        private spinner: NgxSpinnerService) {
    }

    ngOnInit() {
        this.userService.getUserDashboardDataService(this.token).subscribe((data: any) => {
            localStorage.setItem('person', JSON.stringify(data));
            this.person = data;
            this.userService.setPersonList(data);
            this.userService.getPersonList();
            this.notificationForm = this.formBuilder.group({
                status: ['', Validators.required],
                comment: [''],
                isConcussionBaseLineUpToDate: ['', Validators.required],
                applicationId: [''],
                isOnHold: [''],
                journalVoucherNumber: [''],
                personId: null,
                isApproved: new FormControl()
            });
            if (this.person.role === 'Accounts') {
                this.notificationForm.get('journalVoucherNumber').setValidators([Validators.required, Validators.pattern('^\\d{5}(?:[a-zA-Z]{2})?$')]);
            }

            if (this.person.role === 'Admin') {
                this.getRoleListToAssignData();
            }

            if (this.person.role === 'Licensing Department' || this.person.role === 'Licensing Department Head') {
                this.summaryStatus = 'ALL';
                //this.licencingDeptBased();
                this.licencingDeptBasedSearch();
                this.getGeneralTasksSearch();
                this.getOtherTasksListSearch();
            }

            if (this.person.role === 'Senior Medical Officer') {
                this.summaryStatus = 'ALL';
                this.licencingDeptBasedSearch();
                this.getGeneralTasksSearch();
                // this.getWaitingOnOtherTasksList();
            }

            if (this.person.role === 'Medical Liaison') {
                this.licencingDeptBasedSearch();
            }

            if (this.person.role === 'Licensing Department Head') {
                this.getLicensingDeptListToAssignData();
            }

            if (this.person.role === 'Licensing Committee') {
                this.getWaitingOnOtherTasksList();
            }

            if (this.person.role === 'Accounts') {
                this.licencingDeptBasedSearch();
                //  this.getGeneralTasksSearch();
                this.getGeneralTasksSearch();
            }

            if (this.person.role === 'Licensing Online Admin') {
                this.getPersonListDataSearch();
            }

            this.getLicenceTypeListData();
        }, error => {
            if (error.status === 200) {
                return;
            } else if (error.status === 401) {
                localStorage.clear();
                this.toastr.success(error.error.message);
                this.router.navigate(['/signout']);
            } else {
                this.toastr.error(error.message);
            }
        });
        this.elementRef.nativeElement.ownerDocument.body.style.backgroundColor = '#ccc';
    }

    userDataByLOA(personId) {
        this.spinner.show();
        this.userService.getUserDataByLOAService(this.token, personId).subscribe((data: any) => {
            this.spinner.hide();
            if (data.status === true) {
                this.downloadFile(data.data);
                this.toastr.success(data.message);
            } else {
                this.toastr.error(data.message);
            }
        }, error => {
            if (error.status === 200) {
                return;
            } else {
                this.toastr.error(error.message);
            }
            this.spinner.hide();
        });
    }

    getLicenceTypeListData() {
        this.spinner.show();
        this.userService.getLicenceTypeListService(this.token).subscribe((data: any) => {
            if (data.status === true) {
                localStorage.setItem('licenceTypeList', JSON.stringify(data.data));
            }
            this.spinner.hide();
        }, error => {
            if (error.status === 200) {
                return;
            } else {
                this.toastr.error(error.message);
            }
            this.spinner.hide();
        });
    }

    getRoleListToAssignData() {
        this.spinner.show();
        this.userService.getRoleListToAssignService(this.token).subscribe((data: any) => {
            if (data.status === true) {
                localStorage.setItem('rolelist', JSON.stringify(data.data));
            }
            this.spinner.hide();
        }, error => {
            if (error.status === 200) {
                return;
            } else {
                this.toastr.error(error.message);
            }
            this.spinner.hide();
        });
    }

    getLicensingDeptListToAssignData() {
        this.spinner.show();
        this.userService.getLicensingDeptListToAssignService(this.token).subscribe((data: any) => {
            localStorage.setItem('userAssignList', JSON.stringify(data));
            this.userAssignListData();
            this.spinner.hide();
        }, error => {
            if (error.status === 200) {
                return;
            } else {
                this.toastr.error(error.message);
            }
            this.spinner.hide();
        });
    }


    licencingDeptBasedSearch() {
        this.applicationAssignForm = this.formBuilder.group({
            unAssignId: ['', Validators.required],
        });
        this.personListSearch.pipe(debounceTime(300),
            switchMap((term: string) => {
                this.isApplicationTaskLoading = true;
                this.spinner.show('applicationTaskLoader');
                return this.userService.getLicensingApplicationListService(this.token, this.page, this.perPage, this.key, this.direction,
                    this.filterLetter, this.summaryStatus, this.licenceTypeStatusForApplicationTask);
            })).subscribe((data: any) => {
                this.spinner.hide('applicationTaskLoader');
                this.isApplicationTaskLoading=false;
                this.applicationPersonList = data;
                if (data.status === true) {
                    this.createFormApplicationPerson(data);
                    this.configData(data);
                }
            }, error => {
                if (error.status === 200) {
                    return;
                } else {
                    this.toastr.error(error.message);
                }
                this.spinner.hide('applicationTaskLoader');
                this.isApplicationTaskLoading=false;
            });

        this.personListSearch.next('');
    }

    getGeneralTasksSearch() {
        this.personListSearch2.pipe(debounceTime(300),
            switchMap((term: string) => {
                this.isGeneralTaskLoading=true
                this.spinner.show('generalTaskLoader');
                return this.userService.getGeneralTaskService(this.token, this.page2, this.perPage2, this.key2, this.direction2, this.filterLetter2,
                    this.licenceTypeStatusForGeneralTask, this.applicantStatusForGeneralTask);
            })).subscribe((data: any) => {
                this.spinner.hide('generalTaskLoader');
                this.isGeneralTaskLoading=false
                this.generalTasksData = data;
                if (data.status === true) {
                    this.createFormGeneralTasks(data);
                    this.configData2(data);
                }
            }, error => {
                if (error.status === 200) {
                    return;
                } else {
                    this.toastr.error(error.message);
                }
                this.isGeneralTaskLoading=false
                this.spinner.hide('generalTaskLoader');
            });

        this.personListSearch2.next('');
    }

    licencingDeptBased() {
        this.isApplicationTaskLoading = true;
        this.spinner.show('applicationTaskLoader');
        this.applicationAssignForm = this.formBuilder.group({
            unAssignId: ['', Validators.required],
        });
        this.userService.getLicensingApplicationListService(this.token, this.page, this.perPage, this.key, this.direction,
            this.filterLetter, this.summaryStatus, this.licenceTypeStatusForApplicationTask).subscribe((data: any) => {
                this.spinner.hide('applicationTaskLoader');
                this.isApplicationTaskLoading=false
                this.applicationPersonList = data;
                if (data.status === true) {
                    this.createFormApplicationPerson(data);
                    this.configData(data);
                }
            }, error => {
                if (error.status === 200) {
                    return;
                } else {
                    this.toastr.error(error.message);
                }
                this.spinner.hide('applicationTaskLoader');
                this.isApplicationTaskLoading=false
            });
    }

    getGeneralTasksForAccountSearch() {
        this.personListSearch3.pipe(debounceTime(300),
            switchMap((term: string) => {
                this.spinner.show();
                return this.userService.getGeneralTaskListForAccountsService(this.token, this.page, this.perPage, this.key, this.direction,
                    this.filterLetter, this.summaryStatus, this.licenceTypeStatusForApplicationTask);
            })).subscribe((data: any) => {
                this.spinner.hide();
                this.personFeesList = data;
                if (data.status === true) {
                    this.createPersonFeesForm(data);
                    this.configAccountData(data);
                }
            }, error => {
                if (error.status === 200) {
                    return;
                } else {
                    this.toastr.error(error.message);
                }
                this.spinner.hide();
            });

        this.personListSearch3.next('');
    }

    getGeneralTasksForAccounts() {
        this.spinner.show();
        this.userService.getGeneralTaskListForAccountsService(this.token, this.page, this.perPage, this.key, this.direction,
            this.filterLetter, this.summaryStatus, this.licenceTypeStatusForApplicationTask).subscribe((data: any) => {
                this.spinner.hide();
                this.personFeesList = data;
                if (data.status === true) {
                    this.createPersonFeesForm(data);
                    this.configAccountData(data);
                }
            }, error => {
                if (error.status === 200) {
                    return;
                } else {
                    this.toastr.error(error.message);
                }
                this.spinner.hide();
            });
    }


    selectSummaryStatus(event) {
        this.summaryStatus = event.target.value;
        this.page = 1;
        this.licencingDeptBased();
    }

    selectLicenceTypeStatusForApplicationTask(event) {
        this.licenceTypeStatusForApplicationTask = event.target.value;
        this.page = 1;
        this.licencingDeptBased();
    }

    get applicationPersonFormGroup() {
        return this.applicationPersonForm.get('data') as FormArray;
    }

    get personFeesFormGroup() {
        return this.personFeesForm.get('data') as FormArray;
    }

    createFormApplicationPerson(data) {
        this.applicationPersonForm = this.formBuilder.group({
            data: this.formBuilder.array([])
        });
        this.patchApplicationPerson(data);
    }
    createPersonFeesForm(data) {
        this.personFeesForm = this.formBuilder.group({
            data: this.formBuilder.array([])
        });
        this.patchPersonFees(data);
    }

    patchPersonFees(data) {
        const control = <FormArray>this.personFeesForm.get('data');
        data.personFeesLogsListPersons.content.forEach(x => {
            control.push(this.patchValuesApplicationPerson(x));
        });
    }

    patchApplicationPerson(data) {
        const control = <FormArray>this.applicationPersonForm.get('data');
        data.licensingApplicationListPersons.content.forEach(x => {
            control.push(this.patchValuesApplicationPerson(x));
        });
    }

    patchValuesApplicationPerson(x) {
        return this.formBuilder.group({
            task: [x],
            status: ['', Validators.required],
        })
    }

    committeeMeetingReview(event, personId) {
        this.idForCommitteeReport = personId;
        this.checkForCommitteeReport = event.target.checked;
        $('#committeeMeetingReviewModal').modal({
            backdrop: 'static',
            keyboard: false
        });
    }

    submitForCommitteeMeetingReview() {
        const committeeMeetingReviewData = { id: this.idForCommitteeReport, checked: this.checkForCommitteeReport };
        this.spinner.show();
        this.userService.postCommitteeReportService(this.token, committeeMeetingReviewData).subscribe((data: any) => {
            this.spinner.hide();
            $('#committeeMeetingReviewModal').modal('hide');
            if (data.status === true) {
                // this.committeeMeetingReviewDataSuccessMessage = data.message;
                this.toastr.success(data.message);
                // $('#committeeMeetingReviewSuccessModel').modal({
                //     backdrop: 'static',
                //     keyboard: false
                // });
            } else {
                this.toastr.error(data.message);
            }
        }, error => {
            this.spinner.hide();
            if (error.status === 200) {
                return;
            } else {
                this.toastr.error(error.message);
            }
        });
    }

    toCloseCommitteeMeetingReview() {
        $('#committeeMeetingReviewModal').modal('hide');
        $('#committeeMeetingReviewSuccessModel').modal('hide');
        this.licencingDeptBased();
    }

    proceedIssueLicence(applicationId) {
        this.applicationIdForProceedIssueLicence = applicationId;
        $('#proceedIssueLicenceModal').modal({
            backdrop: 'static',
            keyboard: false
        });
    }

    submitForProceedIssueLicence() {
        const proceedIssueLicenceData = { applicationId: this.applicationIdForProceedIssueLicence };
        this.spinner.show();
        this.userService.postProceedIssueLicenceService(this.token, proceedIssueLicenceData).subscribe((data: any) => {
            this.spinner.hide();
            $('#proceedIssueLicenceModal').modal('hide');
            if (data.status === true) {
                this.proceedIssueLicenceDataSuccessMessage = data.message;
                // $('#proceedIssueLicenceSuccessModel').modal({
                //     backdrop: 'static',
                //     keyboard: false
                // });
                this.toastr.success(data.message);
                this.toCloseProceedIssueLicence();
            } else {
                this.toastr.error(data.message);
            }
        }, error => {
            this.spinner.hide();
            if (error.status === 200) {
                return;
            } else {
                this.toastr.error(error.message);
            }
        });
    }

    toCloseProceedIssueLicence() {
        $('#proceedIssueLicenceModal').modal('hide');
        $('#proceedIssueLicenceSuccessModel').modal('hide');
        this.licencingDeptBased();
    }

    filterLetterData(event) {
        var keycode = event.keyCode || event.which;
        this.filterLetter = event.target.value;
        if (keycode == 13) {
            this.page = 1;
            this.personListSearch.next(event.target.value);
        }
    }

    configData(data) {
        data = data.licensingApplicationListPersons;
        this.config = {
            id: 'home',
            itemsPerPage: data.pageable.pageSize,
            currentPage: data.pageable.pageNumber + 1,
            totalItems: data.totalElements,
            totalPage: data.totalPages,
            startElement: data.pageable.pageNumber * data.pageable.pageSize + 1,
            endElement: data.pageable.pageNumber * data.pageable.pageSize + data.numberOfElements
        };
    }


    configAccountData(data) {
        data = data.personFeesLogsListPersons;
        this.config = {
            id: 'home',
            itemsPerPage: data.pageable.pageSize,
            currentPage: data.pageable.pageNumber + 1,
            totalItems: data.totalElements,
            totalPage: data.totalPages,
            startElement: data.pageable.pageNumber * data.pageable.pageSize + 1,
            endElement: data.pageable.pageNumber * data.pageable.pageSize + data.numberOfElements
        };
    }

    setItemsPerPage(event) {
        this.perPage = event.target.value;
        this.page = 1;
        this.licencingDeptBased();
    }

    pageChanged(event, itemsPerPage) {
        this.page = event;
        this.perPage = itemsPerPage;
        setTimeout(() => {
            this.config.currentPage = event;
            this.licencingDeptBased();
        });
    }

    sort(key) {
        this.key = key;
        this.perPage = this.config.itemsPerPage;
        this.reverse = !this.reverse;
        if (this.reverse === false) {
            this.direction = 'DESC';
        } else {
            this.direction = 'ASC';
        }
        this.licencingDeptBased();
    }

    viewLicenceFeesData() {
        this.spinner.show();
        this.userService.viewLicenceFeesDataForUserLicensingApplicationService(this.token, this.showApplicantUserDetails.applicationId).subscribe((data: any) => {
            this.spinner.hide();
            if (data.status === true) {
                this.applicationFeesList = data.data;
                $('#viewLicenceFeesModel').modal('show');
            } else {
                // this.toastr.error(data.message);
                this.toastr.error("Data not available");
            }
        }, error => {
            this.spinner.hide();
            if (error.status === 200) {
                return;
            } else {
                this.toastr.error(error.message);
            }
        });
    }

    viewPersonFeesData(personId) {
        this.spinner.show();
        this.userService.viewPersonFeesDataService(this.token, personId).subscribe((data: any) => {
            this.spinner.hide();
            if (data.status === true) {
                this.applicationFeesList = data.data;
                $('#viewLicenceFeesModel').modal('show');
            } else {
                this.toastr.error(data.message);
            }
        }, error => {
            this.spinner.hide();
            if (error.status === 200) {
                return;
            } else {
                this.toastr.error(error.message);
            }
        });
    }


    selectLicenceFeesDataForSubmit(i, table, link, applicationId, approvalType) {
        this.link = link;
        this.id = applicationId;
        this.requestType = approvalType;
        this.status = this.applicationRequestForm.value.data[i].status;
        this.isEdit = true;
        $('.multipleselect').selectpicker();
        this.spinner.show();
        this.userService.selectLicenceFeesDataForUserLicensingApplicationService(this.token, applicationId).subscribe((data: any) => {
            this.spinner.hide();
            if (data.status === true) {
                this.createFormForLicensingApplicationFees(data);
                this.selectLicenceFeesForLicensingApplication = data.data;
                if (approvalType === "Select More Licence Fees" && this.status == "Rejected") {
                    this.isEdit = false;
                }
                $('#submitTaskRequestAndLicenceFeesDataModal').modal('show');

            } else {
                this.toastr.error(data.message);
            }
        });

    }


    postSelectEmployeeRequest() {
        this.spinner.show();
        let arr = [];
        arr.push(this.employeeForm.value);
        this.userService.postEmployeeCardDataService(this.token, arr, this.applicationId).subscribe((data: any) => {
            this.spinner.hide();
            if (data.status === true) {
                $('#submitTaskRequestAndEmployeeDataModal').modal('hide');
            } else {
                this.toastr.error(data.message);
            }
        });

    }

    createFormForLicensingApplicationFees(data) {
        this.licenceFeesListForm = this.formBuilder.group({
            applicationId: [this.id],
            status: [this.status],
            longName: [this.showApplicantUserDetails.longName],
            licenceType: [data.licenceType],
            totalFee: [0],
            personId: [this.showApplicantUserDetails.id],
            licenceFeesList: this.formBuilder.array([])
        });
        this.patchForLicensingApplicationFees(data.data);
    }

    patchForLicensingApplicationFees(data) {
        const control = <FormArray>this.licenceFeesListForm.get('licenceFeesList');
        data.forEach(x => {
            control.push(this.patchValuesForLicensingApplicationFees(x));
        });
    }

    patchValuesForLicensingApplicationFees(data) {
        return this.formBuilder.group({
            id: [data.id],
            licenceType: [data.licenceType],
            feeDescription: [data.feeDescription],
            feeAmount: [data.feeAmount],
            feeStatus: [data.feeStatus],
            quantity: [data.quantity],
            hriAccount: [data.hriAccount],
            totalByRow: [0],
            edit: [data.edit]
        });
    }

    onTotalFeesChange(i) {
        if (this.licenceFeesListForm.get('licenceFeesList').value[i].quantity === '' || this.licenceFeesListForm.get('licenceFeesList').value[i].quantity === null) {
            this.licenceFeesListForm.get('licenceFeesList').value[i].quantity = 0;
        }
        var quantity = Number(this.licenceFeesListForm.get('licenceFeesList').value[i].quantity);
        var feeAmount = Number(this.licenceFeesListForm.get('licenceFeesList').value[i].feeAmount);
        var totalByRow;
        totalByRow = quantity * feeAmount;
        this.licenceFeesListForm.get('licenceFeesList').value[i].totalByRow = totalByRow;

        var totalFees = 0;
        for (var j = 0; j < this.licenceFeesListForm.get('licenceFeesList').value.length; j++) {
            totalFees += this.licenceFeesListForm.get('licenceFeesList').value[j].totalByRow;
        }
        this.licenceFeesListForm.get('totalFee').setValue('€ ' + totalFees);
    }

    getGeneralTasks() {
        if (this.key2.length > 3) {
            this.isGeneralTaskLoading=true
            this.spinner.show('generalTaskLoader');
            this.userService.getGeneralTaskService(this.token, this.page2, this.perPage2, this.key2, this.direction2, this.filterLetter2,
                this.licenceTypeStatusForGeneralTask, this.applicantStatusForGeneralTask)
                .pipe(debounceTime(300)).subscribe((data: any) => {
                    this.spinner.hide('generalTaskLoader');
                    this.isGeneralTaskLoading=false;
                    this.generalTasksData = data;
                    if (data.status === true) {
                        this.createFormGeneralTasks(data);
                        this.configData2(data);
                    }
                }, error => {
                    if (error.status === 200) {
                        return;
                    } else {
                        this.toastr.error(error.message);
                    }
                    this.spinner.hide('generalTaskLoader');
                    this.isGeneralTaskLoading=false
                });

        }
    }


    public updateModalData() {
        this.editTabForm = true;
    }


    selectLicenceTypeStatusForGeneralTask(event) {
        this.licenceTypeStatusForGeneralTask = event.target.value;
        this.page2 = 1;
        this.getGeneralTasks();
    }

    selectApplicantStatusForGeneralTask(event) {
        this.applicantStatusForGeneralTask = event.target.value;
        this.page2 = 1;
        this.getGeneralTasks();
    }

    get generalTasksFormGroup() {
        return this.generalTasksForm.get('data') as FormArray;
    }

    createFormGeneralTasks(data) {
        this.generalTasksForm = this.formBuilder.group({
            data: this.formBuilder.array([])
        });
        this.patchGeneralTasks(data);
    }

    patchGeneralTasks(data) {
        const control = <FormArray>this.generalTasksForm.get('data');
        data.tasks.content.forEach(x => {
            control.push(this.patchValuesGeneralTasks(x));
        });
    }

    patchValuesGeneralTasks(x) {
        return this.formBuilder.group({
            task: [x],
            status: ['', Validators.required],
        })
    }

    filterLetterData2(event) {
        var keycode = event.keyCode || event.which;
        this.filterLetter2 = event.target.value;
        if (keycode == 13) {
            this.page2 = 1;
            this.personListSearch2.next(event.target.value);

        }
    }

    configData2(data) {
        data = data.tasks;
        this.config2 = {
            id: 'task2',
            itemsPerPage: data.pageable.pageSize,
            currentPage: data.pageable.pageNumber + 1,
            totalItems: data.totalElements,
            totalPage: data.totalPages,
            startElement: data.pageable.pageNumber * data.pageable.pageSize + 1,
            endElement: data.pageable.pageNumber * data.pageable.pageSize + data.numberOfElements
        };
    }

    setItemsPerPage2(event) {
        this.perPage2 = event.target.value;
        this.page2 = 1;
        this.getGeneralTasks();
    }

    pageChanged2(event, itemsPerPage) {
        this.page2 = event;
        this.perPage2 = itemsPerPage;
        setTimeout(() => {
            this.config2.currentPage = event;
            this.getGeneralTasks();
        });
    }

    sort2(key) {
        this.key2 = key;
        this.perPage2 = this.config2.itemsPerPage;
        this.reverse2 = !this.reverse2;
        if (this.reverse2 === false) {
            this.direction2 = 'ASC';
        } else {
            this.direction2 = 'DESC';
        }
        this.getGeneralTasks();
    }

    viewApplicationData(taskToken, task) {
        this.requestType = task.approvalType;
        let licenceType = this.showApplicantUserDetails.licenceType;
        this.link = task.link;
        this.commonViewData(taskToken, task.approvalType, licenceType);
    }

    showFutureDevelopmentData(taskToken, licenceType, approvalType) {
        this.requestType = approvalType;
        this.commonViewData(taskToken, approvalType, licenceType);
    }

    viewGeneralTaskData(taskToken, approvalType, status) {
        this.requestType = approvalType;
        this.status = status;
        let licenceType = this.showGeneralUserDetails.licenceType;
        this.commonViewData(taskToken, approvalType, licenceType);
    }

    viewOtherTaskData(registrationRequestId, approvalType, status) {
        this.requestType = approvalType;
        this.status = status;
        this.commonViewData(registrationRequestId, approvalType, '');
    }

    ViewTrainerFirstTimeTask() {
        $('#trainerFirstTimeModal').modal('show');
    }

    commonViewData(taskToken, approvalType, licenceType) {
        this.spinner.show();
        this.userService.viewApplicationDataService(this.token, taskToken, approvalType, licenceType).subscribe((data: any) => {
            this.spinner.hide();
            if (this.requestType === 'Registration request' || this.requestType === 'Update profile request') {
                this.createForm(data);
                this.userDetails = data.data;
                this.userDetailsForEdit = data.editable;
                this.userFileDetails = data.acknowledgementUnder18DocumentUpload;
                $('#userDetailsModal').modal({
                    backdrop: 'static',
                    keyboard: false
                });
            } else if (this.requestType === 'Trainer register request') {
                this.trainerDetails = data;
                $('#trainerDetailsModal').modal({
                    backdrop: 'static',
                    keyboard: false
                });
            } else if (this.requestType === 'New licence request' || this.requestType === 'Update licence request' || this.requestType === 'Delete licence request') {
                this.userLicenceDetails = data.data;
                $('#userLicenceDetailsModal').modal('show');
            } else if (this.requestType === 'Reference request') {
                this.userReferenceRequestDetails = data.data;
                $('#userReferenceDetailsModal').modal('show');
            } else if (this.requestType === 'Summary document upload request' || this.requestType === 'Renew Summary document upload request'
                || this.requestType === 'Approve Tax Clearance Certificate' || this.requestType === 'Approve Insurance Policy'
                || this.requestType === 'Approve Future Racecourse Development Information') {
                this.summaryFileUpload = data;
                $('#summaryFileUploadModal').modal('show');
            } else if (this.requestType === 'Emergency licence request') {
                this.emergencyLicenceDetailsData = data;
                $('#emergencyLicenceDetailsDataModal').modal('show');
            } else if (this.requestType === 'Future Racecourse Development') {
                this.futureDevelopmentData = data;
                $('#showFutureDevelopmentModal').modal('show');
            } else if (this.requestType === 'Verify premises number (Principal Yard)' || this.requestType === 'Verify premises number (Additional Yard)') {
                this.userEquinePremisesNumberRequestDetails = data.data;
                $('#verifedEPNViewRequestModal').modal('show');
            } else if (this.requestType === 'Employee Card') {
                this.employeeDetails = data;
                $('#submitTaskRequestAndEmployeeDataModal').modal('show');
            } else if (this.requestType === 'Messaging service request') {
                this.messageserviceList = data.messageserviceDtoList;
                $('#showMessagingServiceRequestDataModal').modal('show');
            } else if (this.requestType === 'Assistant trainer request') {
                this.assistantTrainerList = data.assistantTrainerDtoList;
                $('#showAssistantTrainerRequestDataModal').modal('show');
            } else if (this.requestType === 'Authorised representative request') {
                this.authorisedRepresentativeList = data.authorisedRepresentativeDtoList;
                $('#showAuthorisedRepresentativeRequestDataModal').modal('show');
            } else if (this.requestType === 'Medical application request') {
                this.medicalQuestionsData = data;
                $('#medicalDetailsModal').modal('show');
            } else if (this.requestType === 'Selection of application process request') {
                this.viewApplicationAssigningStepsData(data.data);
            } else if (this.requestType === 'Please approve the Principal Yard') {
                this.principalYardData = data.data;
                $('#verifedPrincipalYardRequestModal').modal('show');
            } else if (this.requestType === 'Please approve the Additional Yard') {
                this.additionalYardData = data.data;
                $('#verifedAdditionalYardRequestModal').modal('show');
            } else if (this.requestType === 'Please review clients letters') {
                this.prospectiveOwners = data.data;
                $('#verifedProspectiveOwnersRequestModal').modal('show');
            } else if (this.requestType === 'SBS agreement request') {
                this.sbsAgreement = data.data;
                $('#verifedSBSAgreementRequestModal').modal('show');
            }

        }, error => {
            if (error.status === 200) {
                return;
            } else {
                this.toastr.error(error.message);
            }
            this.spinner.hide();
        });
    }

    createEmployeeForm(data) {
        data = data;
        // this.formLink=data.form;
        // this.imageLink=data.photo;
        // this.employeeForm = this.formBuilder.group({
        //     id: [data.id],
        //     employeeName: [data.employeeName],
        //     dateOfBirth: [data.dateOfBirth],
        //     cardType: [data.cardType],
        // });


    }


    public download(downloadUrl: string): void {
        window.open(downloadUrl, '_blank');
    }

    viewMedicalDetailsData(approvalType) {
        this.spinner.show();
        this.requestType = approvalType;
        this.userService.viewMedicalDataService(this.token, this.showApplicantUserDetails.applicationId).subscribe((data: any) => {
            this.spinner.hide();
            this.medicalQuestionsData = data;
            $('#medicalDetailsModal').modal('show');
        }, error => {
            if (error.status === 200) {
                return;
            } else {
                this.toastr.error(error.message);
            }
            this.spinner.hide();
        });
    }

    public viewApplicationAssigningStepsData(data: any): void {
        this.applicationTabFormGroup = this.formBuilder.group({
            applicationId: [''],
            status: [''],
            trainerApplicationAssigningSteps: this.formBuilder.group({
                id: [!data ? null : (!data.id ? null : data.id)],
                prospectiveOwners: [!data ? false : (!data.prospectiveOwners ? false : data.prospectiveOwners)],
                horses: [!data ? false : (!data.horses ? false : data.horses)],
                employment: [!data ? false : (!data.employment ? false : data.employment)],
                insurance: [!data ? false : (!data.insurance ? false : data.insurance)],
                personnel: [!data ? false : (!data.personnel ? false : data.personnel)],
                experience: [!data ? false : (!data.experience ? false : data.experience)],
                employeeTrainers: [!data ? false : (!data.employeeTrainers ? false : data.employeeTrainers)],
                portfolio: [!data ? false : (!data.portfolio ? false : data.portfolio)],
                corporateStructures: [!data ? false : (!data.corporateStructures ? false : data.corporateStructures)],
                messagingService: [!data ? false : (!data.messagingService ? false : data.messagingService)],
                fitAndProper: [!data ? false : (!data.fitAndProper ? false : data.fitAndProper)],
                principalYard: [!data ? false : (!data.principalYard ? false : data.principalYard)],
                additionalYard: [!data ? false : (!data.additionalYard ? false : data.additionalYard)],
                postInterview: [!data ? false : (!data.postInterview ? false : data.postInterview)],
            })
        });
        $('#trainerFirstTimeModal').modal('show');
    }



    checkAge(dateOfBirth) {
        var dob = dateOfBirth;
        var today = new Date();
        var birthDate = new Date(dob);
        var age = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        this.under18Age = age;
    }

    viewApplicantSummaryDetails(showApplicantUserDetails) {
        this.showApplicantUserDetails = showApplicantUserDetails;
        this.spinner.show();
        this.userService.getViewApplicantSummaryDetailsService(this.token, this.showApplicantUserDetails.applicationId).subscribe((data: any) => {
            this.spinner.hide();
            this.checkAge(this.showApplicantUserDetails.dateOfBirth);
            this.isRenewalApplication = this.showApplicantUserDetails.isRenewLicensingApplication;
            if (data.status === true) {
               if ((!(this.showApplicantUserDetails.licenceType == 'Trainer')) && (this.isRenewalApplication === false || this.isRenewalApplication === null)) {
                    this.zero = data.applicationSummary.find(x => x.subPoint.match('1.a.'));
                    this.one = data.applicationSummary.find(x => x.subPoint.match('1.b.'));
                    this.two = data.applicationSummary.find(x => x.subPoint.match('1.c.'));
                    this.three = data.applicationSummary.find(x => x.subPoint.match('2.a.'));
                    this.four = data.applicationSummary.find(x => x.subPoint.match('3.a.'));
                    this.five = data.applicationSummary.find(x => x.subPoint.match('3.b.'));
                    this.six = data.applicationSummary.find(x => x.subPoint.match('3.c.'));
                    this.seven = data.applicationSummary.find(x => x.subPoint.match('3.d.'));
                    this.eight = data.applicationSummary.find(x => x.subPoint.match('4.a.'));
                    this.nine = data.applicationSummary.find(x => x.subPoint.match('5.a.'));
                    this.ten = data.applicationSummary.find(x => x.subPoint.match('5.b.'));
                    this.eleven = data.applicationSummary.find(x => x.subPoint.match('5.c.'));
                    this.twelve = data.applicationSummary.find(x => x.subPoint.match('6.a.'));
                    this.thirteen = data.applicationSummary.find(x => x.subPoint.match('7.a.'));
                } else if (this.showApplicantUserDetails.licenceType == 'Trainer') {
                    if (this.isRenewalApplication === true) {
                        this.zero = data.applicationSummary.find(x => x.subPoint.match('1.a.'));
                        this.one = data.applicationSummary.find(x => x.subPoint.match('2.a.'));
                        this.two = data.applicationSummary.find(x => x.subPoint.match('2.b.'));
                        this.three = data.applicationSummary.find(x => x.subPoint.match('2.c.'));
                        this.four = data.applicationSummary.find(x => x.subPoint.match('2.d.'));
                        this.five = data.applicationSummary.find(x => x.subPoint.match('2.e.'));
                        this.six = data.applicationSummary.find(x => x.subPoint.match('3.a.'));
                        this.seven = data.applicationSummary.find(x => x.subPoint.match('3.b.'));
                        this.eight = data.applicationSummary.find(x => x.subPoint.match('3.c.'));
                        this.nine = data.applicationSummary.find(x => x.subPoint.match('3.d.'));
                        this.ten = data.applicationSummary.find(x => x.subPoint.match('3.e.'));
                        this.eleven = data.applicationSummary.find(x => x.subPoint.match('4.a.'));
                        this.twelve = data.applicationSummary.find(x => x.subPoint.match('5.a.'));
                        this.thirteen = data.applicationSummary.find(x => x.subPoint.match('6.a.'));
                        this.fourteen = data.applicationSummary.find(x => x.subPoint.match('6.b.'));
                        this.fifteen = data.applicationSummary.find(x => x.subPoint.match('7.a.'));
                    } else {
                        this.zero = data.applicationSummary.find(x => x.subPoint.match('1.a.'));
                        this.one = data.applicationSummary.find(x => x.subPoint.match('1.b.'));
                        this.two = data.applicationSummary.find(x => x.subPoint.match('1.c.'));
                        this.three = data.applicationSummary.find(x => x.subPoint.match('1.d.'));
                        this.four = data.applicationSummary.find(x => x.subPoint.match('1.e.'));
                        this.five = data.applicationSummary.find(x => x.subPoint.match('1.f.'));
                        this.six = data.applicationSummary.find(x => x.subPoint.match('1.g.'));
                        this.seven = data.applicationSummary.find(x => x.subPoint.match('2.a.'));
                        this.eight = data.applicationSummary.find(x => x.subPoint.match('2.b.'));
                        this.nine = data.applicationSummary.find(x => x.subPoint.match('3.a.'));
                        this.ten = data.applicationSummary.find(x => x.subPoint.match('4.a.'));
                        this.eleven = data.applicationSummary.find(x => x.subPoint.match('4.b.'));
                    }

                } else {
                    if (this.showApplicantUserDetails.licenceType == 'Apprentice') {
                        this.zero = data.applicationSummary.find(x => x.subPoint.match('1.c.'));
                    } else {
                        this.zero = data.applicationSummary.find(x => x.subPoint.match('1.a.'));
                    }
                    this.one = data.applicationSummary.find(x => x.subPoint.match('2.a.'));
                    this.two = data.applicationSummary.find(x => x.subPoint.match('3.a.'));
                    this.three = data.applicationSummary.find(x => x.subPoint.match('3.b.'));
                    this.four = data.applicationSummary.find(x => x.subPoint.match('4.a.'));
                    this.five = data.applicationSummary.find(x => x.subPoint.match('5.a.'));
                }

               // this.customPatchValue(this.showApplicantUserDetails.licenceType, data.applicationSummary, this.isRenewalApplication);
            }
            this.applicantDetails = data;
            $('#viewApplicantSummaryDetailsModal').modal('show');

        }, error => {
            if (error.status === 200) {
                return;
            } else {
                this.toastr.error(error.message);
            }
            this.spinner.hide();
        });
    }

   



    viewLicensingApplicationDataByLD(approvalType) {
        let id = this.showApplicantUserDetails.applicationId;
        this.viewLicensingApplicationData(id, approvalType);
    }

    viewLicensingApplicationDataByLDH(showApplicantUserDetails) {
        this.showApplicantUserDetails = showApplicantUserDetails;
        this.checkAge(showApplicantUserDetails.dateOfBirth);
        let id = showApplicantUserDetails.applicationId;
        this.viewLicensingApplicationData(id, '');
    }

    viewLicensingApplicationData(id, approvalType) {
        this.spinner.show();
        this.userService.viewLicensingApplicationDataService(this.token, id).subscribe((data: any) => {
            this.spinner.hide();
            this.requestType = approvalType;
            this.isRenewalApplication = this.showApplicantUserDetails.isRenewLicensingApplication;
            if (this.showApplicantUserDetails.licenceType === 'Jockey Valet') {
                this.jockeyValetApplicationDetails = data;
                $('#jockeyValetApplicationDetailsModel').modal('show');
            } else if (this.showApplicantUserDetails.licenceType === 'Jockey Agent') {
                this.jockeyAgentApplicationDetails = data;
                $('#jockeyAgentApplicationDetailsModal').modal('show');
            } else {
                if (data.status === true) {
                    this.customPatchValue(this.showApplicantUserDetails.licenceType, data.data.applicationSummaryList, this.isRenewalApplication);

                    /**if (!(this.showApplicantUserDetails.licenceType == 'Trainer' || this.showApplicantUserDetails.licenceType == 'Apprentice') && this.showApplicantUserDetails.licensingApplicationFirstTimeRenewal === 'First Time') {
                        this.zero = data.data.applicationSummaryList.find(x => x.subPoint.match('1.a.'));
                        this.one = data.data.applicationSummaryList.find(x => x.subPoint.match('1.b.'));
                        this.two = data.data.applicationSummaryList.find(x => x.subPoint.match('1.c.'));
                        this.three = data.data.applicationSummaryList.find(x => x.subPoint.match('2.a.'));
                        this.four = data.data.applicationSummaryList.find(x => x.subPoint.match('3.a.'));
                        this.five = data.data.applicationSummaryList.find(x => x.subPoint.match('3.b.'));
                        this.six = data.data.applicationSummaryList.find(x => x.subPoint.match('3.c.'));
                        this.seven = data.data.applicationSummaryList.find(x => x.subPoint.match('3.d.'));
                        this.eight = data.data.applicationSummaryList.find(x => x.subPoint.match('4.a.'));
                        this.nine = data.data.applicationSummaryList.find(x => x.subPoint.match('5.a.'));
                        this.ten = data.data.applicationSummaryList.find(x => x.subPoint.match('5.b.'));
                        this.eleven = data.data.applicationSummaryList.find(x => x.subPoint.match('5.c.'));
                        this.twelve = data.data.applicationSummaryList.find(x => x.subPoint.match('6.a.'));
                        this.thirteen = data.data.applicationSummaryList.find(x => x.subPoint.match('7.a.'));
                    }else if (this.showApplicantUserDetails.licenceType == 'Apprentice') {
                        this.zero = data.data.applicationSummaryList.find(x => x.subPoint.match('1.a.'));
                        this.one = data.data.applicationSummaryList.find(x => x.subPoint.match('1.b.'));
                        this.two = data.data.applicationSummaryList.find(x => x.subPoint.match('1.c.'));
                        this.three = data.data.applicationSummaryList.find(x => x.subPoint.match('2.a.'));
                        this.four = data.data.applicationSummaryList.find(x => x.subPoint.match('3.a.'));
                        this.five = data.data.applicationSummaryList.find(x => x.subPoint.match('3.b.'));
                        this.six = data.data.applicationSummaryList.find(x => x.subPoint.match('4.a.'));
                    } else if (this.showApplicantUserDetails.licenceType == 'Trainer' && this.isRenewalApplication === true) {
                        this.zero = data.data.applicationSummaryList.find(x => x.subPoint.match('1.a.'));
                        this.one = data.data.applicationSummaryList.find(x => x.subPoint.match('2.a.'));
                        this.two = data.data.applicationSummaryList.find(x => x.subPoint.match('2.b.'));
                        this.three = data.data.applicationSummaryList.find(x => x.subPoint.match('2.c.'));
                        this.four = data.data.applicationSummaryList.find(x => x.subPoint.match('2.d.'));
                        this.five = data.data.applicationSummaryList.find(x => x.subPoint.match('2.e.'));
                        this.six = data.data.applicationSummaryList.find(x => x.subPoint.match('3.a.'));
                        this.seven = data.data.applicationSummaryList.find(x => x.subPoint.match('3.b.'));
                        this.eight = data.data.applicationSummaryList.find(x => x.subPoint.match('3.c.'));
                        this.nine = data.data.applicationSummaryList.find(x => x.subPoint.match('3.d.'));
                        this.ten = data.data.applicationSummaryList.find(x => x.subPoint.match('4.a.'));
                        this.eleven = data.data.applicationSummaryList.find(x => x.subPoint.match('5.a.'));
                        this.twelve = data.data.applicationSummaryList.find(x => x.subPoint.match('6.a.'));
                        this.thirteen = data.data.applicationSummaryList.find(x => x.subPoint.match('6.b.'));
                        this.fourteen = data.data.applicationSummaryList.find(x => x.subPoint.match('7.a.'));
                       // this.fifteen = data.data.applicationSummaryList.find(x => x.subPoint.match('7.a.'));

                    } else if (this.showApplicantUserDetails.licenceType == 'Trainer' && this.isRenewalApplication === false) {
                        this.zero = data.data.applicationSummaryList.find(x => x.subPoint.match('1.a.'));
                        this.one = data.data.applicationSummaryList.find(x => x.subPoint.match('1.b.'));
                        this.two = data.data.applicationSummaryList.find(x => x.subPoint.match('1.c.'));
                        this.three = data.data.applicationSummaryList.find(x => x.subPoint.match('1.d.'));
                        this.four = data.data.applicationSummaryList.find(x => x.subPoint.match('1.e.'));
                        this.five = data.data.applicationSummaryList.find(x => x.subPoint.match('1.f.'));
                        this.six = data.data.applicationSummaryList.find(x => x.subPoint.match('1.g.'));
                        this.seven = data.data.applicationSummaryList.find(x => x.subPoint.match('2.a.'));
                        this.eight = data.data.applicationSummaryList.find(x => x.subPoint.match('2.b.'));
                        this.nine = data.data.applicationSummaryList.find(x => x.subPoint.match('3.a.'));
                        this.ten = data.data.applicationSummaryList.find(x => x.subPoint.match('4.a.'));
                        this.eleven = data.data.applicationSummaryList.find(x => x.subPoint.match('4.b.'));

                    } else {
                        this.zero = data.data.applicationSummaryList.find(x => x.subPoint.match('1.a.'));
                        this.one = data.data.applicationSummaryList.find(x => x.subPoint.match('2.a.'));
                        this.two = data.data.applicationSummaryList.find(x => x.subPoint.match('3.a.'));
                        this.three = data.data.applicationSummaryList.find(x => x.subPoint.match('3.b.'));
                        this.four = data.data.applicationSummaryList.find(x => x.subPoint.match('4.a.'));
                        this.five = data.data.applicationSummaryList.find(x => x.subPoint.match('5.a.'));
                    }**/

                }
                this.licensingApplicationDetails = data;
                $('.nav-link').removeClass('active');
                $('.tab-pane').removeClass('active');
                $("#pills-profile-tab").tab('show');
                $('#pills-profile-tab').addClass('active');
                $('#licensingApplicationDetailsModal').modal('show');
            }
        }, error => {
            if (error.status === 200) {
                return;
            } else {
                this.toastr.error(error.message);
            }
            this.spinner.hide();
        });
    }

    public customPatchValue(licenceType: String, data: any, isFirstTimeRenewal: Boolean) {
        if (licenceType == 'Apprentice') {

            this.zero = data.find(x => x.subPoint.match('1.a.')) ? data.find(x => x.subPoint.match('1.a.')) : null;
            this.one = data.find(x => x.subPoint.match('1.b.')) ? data.find(x => x.subPoint.match('1.b.')) : null;
            this.two = data.find(x => x.subPoint.match('1.c.')) ? data.find(x => x.subPoint.match('1.c.')) : null;
            this.three = data.find(x => x.subPoint.match('2.a.')) ? data.find(x => x.subPoint.match('2.a.')) : null;
            this.four = data.find(x => x.subPoint.match('3.a.')) ? data.find(x => x.subPoint.match('3.a.')) : null;
            this.five = data.find(x => x.subPoint.match('3.b.')) ? data.find(x => x.subPoint.match('3.b.')) : null;
            this.six = data.find(x => x.subPoint.match('4.a.')) ? data.find(x => x.subPoint.match('4.a.')) : null;
            

        } if (licenceType == 'Trainer') {
            if (isFirstTimeRenewal === false) {

                this.zero = data.find(x => x.subPoint.match('1.a.')) ? data.find(x => x.subPoint.match('1.a.')) : null;
                this.one = data.find(x => x.subPoint.match('1.b.')) ? data.find(x => x.subPoint.match('1.b.')) : null;
                this.two = data.find(x => x.subPoint.match('1.c.')) ? data.find(x => x.subPoint.match('1.c.')) : null;
                this.three = data.find(x => x.subPoint.match('1.d.')) ? data.find(x => x.subPoint.match('1.d.')) : null;
                this.four = data.find(x => x.subPoint.match('1.e.')) ? data.find(x => x.subPoint.match('1.e.')) : null;
                this.five = data.find(x => x.subPoint.match('1.f.')) ? data.find(x => x.subPoint.match('1.f.')) : null;
                this.six = data.find(x => x.subPoint.match('1.g.')) ? data.find(x => x.subPoint.match('1.g.')) : null;
                this.seven = data.find(x => x.subPoint.match('2.a.')) ? data.find(x => x.subPoint.match('2.a.')) : null;
                this.eight = data.find(x => x.subPoint.match('2.b.')) ? data.find(x => x.subPoint.match('2.b.')) : null;
                this.nine = data.find(x => x.subPoint.match('3.a.')) ? data.find(x => x.subPoint.match('3.a.')) : null;
                this.ten = data.find(x => x.subPoint.match('4.a.')) ? data.find(x => x.subPoint.match('4.a.')) : null;
                this.eleven = data.find(x => x.subPoint.match('4.b.')) ? data.find(x => x.subPoint.match('4.b.')) : null;

            } else if (isFirstTimeRenewal === true) {
                this.zero = data.find(x => x.subPoint.match('1.a.')) ? data.find(x => x.subPoint.match('1.a.')) : null;
                this.one = data.find(x => x.subPoint.match('2.a.')) ? data.find(x => x.subPoint.match('2.a.')) : null;
                this.two = data.find(x => x.subPoint.match('2.b.')) ? data.find(x => x.subPoint.match('2.a.')) : null;
                this.three = data.find(x => x.subPoint.match('2.c.')) ? data.find(x => x.subPoint.match('2.c.')) : null;
                this.four = data.find(x => x.subPoint.match('2.d.')) ? data.find(x => x.subPoint.match('2.d.')) : null;
                this.five = data.find(x => x.subPoint.match('2.e.')) ? data.find(x => x.subPoint.match('2.e.')) : null;
                this.six = data.find(x => x.subPoint.match('3.a.')) ? data.find(x => x.subPoint.match('3.a.')) : null;
                this.seven = data.find(x => x.subPoint.match('3.b.')) ? data.find(x => x.subPoint.match('3.b.')) : null;
                this.eight = data.find(x => x.subPoint.match('3.c.')) ? data.find(x => x.subPoint.match('3.c.')) : null;
                this.nine = data.find(x => x.subPoint.match('3.d.')) ? data.find(x => x.subPoint.match('3.d.')) : null;
                this.ten = data.find(x => x.subPoint.match('3.e.')) ? data.find(x => x.subPoint.match('3.e.')) : null;
                this.eleven = data.find(x => x.subPoint.match('4.a.')) ? data.find(x => x.subPoint.match('4.a.')) : null;
                this.twelve = data.find(x => x.subPoint.match('5.a.')) ? data.find(x => x.subPoint.match('5.a.')) : null;
                this.thirteen = data.find(x => x.subPoint.match('6.a.')) ? data.find(x => x.subPoint.match('6.a.')) : null;
                this.fourteen = data.find(x => x.subPoint.match('6.b.')) ? data.find(x => x.subPoint.match('6.b.')) : null;
                 this.fifteen = data.find(x => x.subPoint.match('7.a.')) ? data.find(x => x.subPoint.match('7.a.')) : null;
            }
        } else if (!(licenceType == 'Trainer' || licenceType == 'Apprentice')) {
            if (isFirstTimeRenewal === false) {
                this.zero = data.find(x => x.subPoint.match('1.a.')) ? data.find(x => x.subPoint.match('1.a.')) : null;
                this.one = data.find(x => x.subPoint.match('1.b.')) ? data.find(x => x.subPoint.match('1.b.')) : null;
                this.two = data.find(x => x.subPoint.match('1.c.')) ? data.find(x => x.subPoint.match('1.c.')) : null;
                this.three = data.find(x => x.subPoint.match('2.a.')) ? data.find(x => x.subPoint.match('2.a.')) : null;
                this.four = data.find(x => x.subPoint.match('3.a.')) ? data.find(x => x.subPoint.match('3.a.')) : null;
                this.five = data.find(x => x.subPoint.match('3.b.')) ? data.find(x => x.subPoint.match('3.b.')) : null;
                this.six = data.find(x => x.subPoint.match('3.c.')) ? data.find(x => x.subPoint.match('3.c.')) : null;
                this.seven = data.find(x => x.subPoint.match('3.d.')) ? data.find(x => x.subPoint.match('3.d.')) : null;
                this.eight = data.find(x => x.subPoint.match('4.a.')) ? data.find(x => x.subPoint.match('4.a.')) : null;
                this.nine = data.find(x => x.subPoint.match('5.a.')) ? data.find(x => x.subPoint.match('5.a.')) : null;
                this.ten = data.find(x => x.subPoint.match('5.b.')) ? data.find(x => x.subPoint.match('5.b.')) : null;
                this.eleven = data.find(x => x.subPoint.match('5.c.')) ? data.find(x => x.subPoint.match('5.c.')) : null;
                this.twelve = data.find(x => x.subPoint.match('6.a.')) ? data.find(x => x.subPoint.match('6.a.')) : null;
                this.thirteen = data.find(x => x.subPoint.match('7.a.')) ? data.find(x => x.subPoint.match('7.a.')) : null;
            } else if (isFirstTimeRenewal === true) {
                this.zero = data.find(x => x.subPoint.match('1.a.')) ? data.find(x => x.subPoint.match('1.a.')) : null;
                this.one = data.find(x => x.subPoint.match('2.a.')) ? data.find(x => x.subPoint.match('2.a.')) : null;
                this.two = data.find(x => x.subPoint.match('3.a.')) ? data.find(x => x.subPoint.match('3.a.')) : null;
                this.three = data.find(x => x.subPoint.match('3.b.')) ? data.find(x => x.subPoint.match('3.b.')) : null;
                this.four = data.find(x => x.subPoint.match('4.a.')) ? data.find(x => x.subPoint.match('4.a.')) : null;
                this.five = data.find(x => x.subPoint.match('5.a.')) ? data.find(x => x.subPoint.match('5.a.')) : null;
            }

        }


    }

    prepareForCommitteeMeetingData() {
        this.spinner.show();
        this.userService.prepareForCommitteeMeetingService(this.token).subscribe((data: any) => {
            if (data.status === true) {
                this.toastr.success(data.message);
                this.getOtherTasksList();
            } else {
                this.spinner.hide();
                this.toastr.error(data.message);
            }
        }, error => {
            if (error.status === 200) {
                return;
            } else {
                this.toastr.error(error.message);
            }
            this.spinner.hide();
        });
    }

    publishDetailsInRacingCalendarData() {
        this.spinner.show();
        this.userService.publishDetailsInRacingCalendarService(this.token).subscribe((data: any) => {
            if (data.status === true) {
                this.toastr.success(data.message);
                this.getOtherTasksList();
            } else {
                this.spinner.hide();
                this.toastr.error(data.message);
            }
        }, error => {
            if (error.status === 200) {
                return;
            } else {
                this.toastr.error(error.message);
            }
            this.spinner.hide();
        });
    }

    toggleEdit() {
        this.editing = false;
    }

    toggleCancel() {
        this.editing = true;
    }

    createForm(data) {
        data = data.data;
        this.userDetailsForm = this.formBuilder.group({
            id: [data.id],
            title: [data.title],
            firstName: [data.firstName, [Validators.required, Validators.pattern('^[a-zA-Z\\d]+(([\\\'\\- ][a-zA-Z\\d ])?[a-zA-Z\\d]*[\\.]*)*$'), Validators.minLength(2)]],
            middleName: [data.middleName, [Validators.pattern('^[a-zA-Z\\d]+(([\\\'\\- ][a-zA-Z\\d ])?[a-zA-Z\\d]*[\\.]*)*$'), Validators.minLength(2)]],
            surname: [data.surname, [Validators.required, Validators.pattern('^[a-zA-Z\\d]+(([\\\'\\- ][a-zA-Z\\d ])?[a-zA-Z\\d]*[\\.]*)*$'), Validators.minLength(2)]],
            dateOfBirth: [data.dateOfBirth, Validators.required],
            gender: [data.gender, Validators.required],
            email: [data.email, [Validators.required, Validators.pattern('^[a-zA-Z0-9][a-zA-Z0-9-_\\.]+@([a-zA-Z]|[a-zA-Z0-9]?[a-z0-9-]+[a-zA-Z0-9])\\.[a-zA-Z0-9]{2,10}(?:\\.[a-zA-Z]{2,10})?$')]],
            addressLine1: [data.addressLine1, [Validators.required, Validators.pattern('^[a-zA-Z\\d]+(([\\\'\\,\\.\\- #][a-zA-Z\\d ])?[a-zA-Z\\d]*[\\.\\,\\(\\)\\[\\]\\{\\}]*)*$')]],
            addressLine2: [data.addressLine2, [Validators.required, Validators.pattern('^[a-zA-Z\\d]+(([\\\'\\,\\.\\- #][a-zA-Z\\d ])?[a-zA-Z\\d]*[\\.\\,\\(\\)\\[\\]\\{\\}]*)*$')]],
            addressLine3: [data.addressLine3, Validators.pattern('^[a-zA-Z\\d]+(([\\\'\\,\\.\\- #][a-zA-Z\\d ])?[a-zA-Z\\d]*[\\.\\,\\(\\)\\[\\]\\{\\}]*)*$')],
            county: [data.county, Validators.required],
            country: [data.country, Validators.required],
            eircode: [data.eircode, [Validators.required, Validators.pattern('[A-Za-z0-9]{6,7}')]],

            phoneCountryCode: [data.phoneCountryCode],
            middlePhoneNumber: [data.middlePhoneNumber, [Validators.pattern('^0[0-9]{2}')]],
            phoneNumber: [data.phoneNumber, Validators.pattern('[0-9]\\d{6}')],

            mobilePhoneNumber: [data.mobilePhoneNumber, [Validators.required, Validators.pattern('[0-9]\\d{6}')]],
            middleMobilePhoneNumber: [data.middleMobilePhoneNumber, Validators.required],
            mobileCountryCode: [data.mobileCountryCode, Validators.required],
            licence: [data.licenceType]
        }, { validator: CustomValidators.prototype.endDateCheck });
    }

    number_keyPress(event: any) {
        const pattern = /[0-9]/;
        const inputChar = String.fromCharCode(event.charCode);
        if (!pattern.test(inputChar)) {
            event.preventDefault();
        }
    }

    name_keyPress(event: any) {
        const pattern = /[a-z,A-Z]/;
        const inputChar = String.fromCharCode(event.charCode);
        if (!pattern.test(inputChar)) {
            event.preventDefault();
        }
    }

    eircode_keyPress(event: any) {
        const pattern = /[A-Za-z0-9]/;
        const inputChar = String.fromCharCode(event.charCode);
        if (!pattern.test(inputChar)) {
            event.preventDefault();
        }
    }

    submitEditedUserDetails() {
        this.submitted = true;
        if (this.userDetailsForm.invalid) {
            return;
        }
        this.loading = true;
        this.spinner.show();
        this.userService.postUserDetailsByLicensingDeptService(this.token, this.userDetailsForm.value, this.requestType).subscribe((data: any) => {
            if (data.status === true) {
                this.editing = true;
                this.submitted = false;
                this.spinner.hide();
                $('#userDetailsModal').modal('hide');
                this.toastr.success(data.message);
            }
            this.spinner.hide();
            $('#applicationRequestListModel').modal('hide');
        }, error => {
            if (error.status === 200) {
                return;
            } else {
                this.toastr.error(error.message);
            }
            this.spinner.hide();
        });
    }

    downloadFile(url) {
        window.open(url, "_blank");
    }

    userAssignListData() {
        const assignRole = JSON.parse(localStorage.getItem('userAssignList'));
        this.userAssignList = assignRole;
    }


    public closeAlert(alert: any) {
        const index: number = this.alerts.indexOf(alert);
        this.alerts.splice(index, 1);
    }

    doClaim(licensingApplicationId) {
        this.claimOrAssignForm = this.formBuilder.group({
            licensingApplicationId: [licensingApplicationId],
        });
        $('#postClaimOrAssignDataModel').modal('show');
    }

    doClaimPerson(personId) {
        this.claimOrAssignForm = this.formBuilder.group({
            personId: [personId],
        });
        $('#postClaimPersonDataModel').modal('show');
    }

    doAssign(licensingApplicationId) {
        this.submitted = true;
        if (this.applicationAssignForm.invalid) {
            return;
        }
        this.loading = true;
        const unAssignId = this.applicationAssignForm.value.unAssignId;
        this.claimOrAssignForm = this.formBuilder.group({
            licensingApplicationId: [licensingApplicationId],
            assignedPersonId: [unAssignId]
        });
        $('#postClaimOrAssignDataModel').modal('show');
    }


    claimPersonData() {
        this.spinner.show();
        this.userService.postClaimService(this.token, this.claimOrAssignForm.value).subscribe((data: any) => {
            this.spinner.hide();
            $('#postClaimPersonDataModel').modal('hide');
            if (data.status === true) {
                this.toastr.success(data.message);
                this.getGeneralTasks();
            } else {
                this.toastr.error(data.message);
            }
        }, error => {
            if (error.status === 200) {
                return;
            } else {
                this.toastr.error(error.message);
            }
            this.spinner.hide();
        });
    }

    claimOrAssignData() {
        this.spinner.show();
        this.userService.postClaimOrAssignService(this.token, this.claimOrAssignForm.value).subscribe((data: any) => {
            this.spinner.hide();
            $('#postClaimOrAssignDataModel').modal('hide');
            if (data.status === true) {
                this.toastr.success(data.message);
                this.licencingDeptBased();
            } else {
                this.toastr.error(data.message);
            }
        }, error => {
            if (error.status === 200) {
                return;
            } else {
                this.toastr.error(error.message);
            }
            this.spinner.hide();
        });
    }

    showUserTask(showApplicantUserDetails) {
        this.spinner.show();
        this.showApplicantUserDetails = showApplicantUserDetails;
        this.personId = showApplicantUserDetails.personId;
        this.applicationId = showApplicantUserDetails.applicationId;
        this.checkAge(showApplicantUserDetails.dateOfBirth);
        this.userService.getLicensingDeptTaskByUserService(this.token, this.applicationId, this.page3, this.perPage3, this.key3, this.direction3, this.filterLetter3).subscribe((data: any) => {
            this.spinner.hide();
            this.applicationRequestList = data;
            $('#applicationRequestListModel').modal({
                backdrop: 'static',
                keyboard: false
            });
            if (data.status === true) {
                this.concussionDate = data.concussionDate;
                this.createFormLicensingApplication(data);
                this.configData3(data);
            }
        }, error => {
            if (error.status === 200) {
                return;
            } else {
                this.toastr.error(error.message);
            }
            this.spinner.hide();
        });
    }



    showUserFeesTask(showApplicantUserDetails) {
        if (this.key3.length > 3) {
            this.spinner.show();
            this.showApplicantUserDetails = showApplicantUserDetails;
            this.personId = showApplicantUserDetails.personId;
            this.userService.getAccountTaskByUserService(this.token, this.personId, this.page3, this.perPage3, this.key3, this.direction3, this.filterLetter3).pipe(debounceTime(300)).subscribe((data: any) => {
                this.spinner.hide();
                this.applicationRequestList = data;
                $('#applicationRequestListModel').modal({
                    backdrop: 'static',
                    keyboard: false
                });
                if (data.status === true) {
                    this.concussionDate = data.concussionDate;
                    this.createFormLicensingApplication(data);
                    this.configData3(data);
                }
            }, error => {
                if (error.status === 200) {
                    return;
                } else {
                    this.toastr.error(error.message);
                }
                this.spinner.hide();
            });
        }

    }


    viewGeneralRequestByPerson(showGeneralUserDetails) {
        this.spinner.show();
        this.showGeneralUserDetails = showGeneralUserDetails;
        // this.generalPersonId = showGeneralUserDetails.id;
        this.personId = showGeneralUserDetails.personId;
        this.userService.getAccountTaskByUserService(this.token, this.personId, this.page3, this.perPage3, this.key3, this.direction3, this.filterLetter3).pipe(debounceTime(300)).subscribe((data: any) => {
            this.spinner.hide();
            this.generalPersonTaskList = data;
            $('#personGeneralRequestListModal').modal({
                backdrop: 'static',
                keyboard: false
            });
            if (data.status === true) {
                this.createFormGeneralDataByPerson(data);
                this.configData4(data);
            }
        }, error => {
            if (error.status === 200) {
                return;
            } else {
                this.toastr.error(error.message);
            }
            this.spinner.hide();
        });
    }


    get applicationRequestFormGroup() {
        return this.applicationRequestForm.get('data') as FormArray;
    }

    createFormLicensingApplication(data) {
        this.applicationRequestForm = this.formBuilder.group({
            data: this.formBuilder.array([])
        });
        this.patchLicencingApplication(data);
    }

    patchLicencingApplication(data) {
        const control = <FormArray>this.applicationRequestForm.get('data');
        data.tasks.content.forEach(x => {
            control.push(this.patchValuesLicensingApplication(x));
        });
    }

    patchValuesLicensingApplication(x) {
        return this.formBuilder.group({
            task: [x],
            status: [x.status, Validators.required],
        })
    }

    filterLetterData3(filterLetter) {
        this.filterLetter3 = filterLetter;
        if (filterLetter.length > 2 || filterLetter.length === 0) {
            this.page3 = 1;
            this.showUserTask(this.showApplicantUserDetails);
        }
    }

    configData3(data) {
        data = data.tasks;
        this.config3 = {
            id: 'task',
            itemsPerPage: data.pageable.pageSize,
            currentPage: data.pageable.pageNumber + 1,
            totalItems: data.totalElements,
            totalPage: data.totalPages,
            startElement: data.pageable.pageNumber * data.pageable.pageSize + 1,
            endElement: data.pageable.pageNumber * data.pageable.pageSize + data.numberOfElements
        };
    }

    setItemsPerPage3(event) {
        this.perPage3 = event.target.value;
        this.page3 = 1;
        this.showUserTask(this.showApplicantUserDetails);
    }

    pageChanged3(event, itemsPerPage) {
        this.page3 = event;
        this.perPage3 = itemsPerPage;
        setTimeout(() => {
            this.config3.currentPage = event;
            this.showUserTask(this.showApplicantUserDetails);
        });
    }

    sort3(key) {
        this.key3 = key;
        this.perPage3 = this.config3.itemsPerPage;
        this.reverse3 = !this.reverse3;
        if (this.reverse3 === false) {
            this.direction3 = 'ASC';
        } else {
            this.direction3 = 'DESC';
        }
        this.showUserTask(this.showApplicantUserDetails);
    }

    getPersonRequestObject(i, table, task) {
        this.link = task.link;
        this.requestType = task.approvalType;
        this.table = table;

        if (table === 'ApplicationTask') {
            this.id = this.showApplicantUserDetails.applicationId;
            this.status = this.applicationRequestForm.value.data[i].status;
        } else if (table === 'GeneralTask') {
            this.id = this.showGeneralUserDetails.applicationId;
            this.personId = this.showGeneralUserDetails.id;
            this.status = this.generalPersonTaskForm.value.data[i].status;
        } else if (table === 'OtherTask') {
            this.id = task.id;
            this.status = this.otherTaskForm.value.data[i].status;
        }


        if (task.approvalType === 'Registration request' && this.status === 'Approved' && task.checkDuplicatedPerson === true) {
            this.duplicationDescription = task.description;
            $("#duplicateUser").html("Duplicate User Account - " + this.showGeneralUserDetails.longName);
            $('#duplicationInformationModal').modal('show');
        } else if (task.approvalType === 'Trainer register request' && this.status === 'Approved') {
            this.status = this.generalPersonTaskForm.value.data[i].status;
            this.getTrainerData();
            $('#trainerRegisterModal').modal('show');
        } else if (task.approvalType === 'Select Fees') {
            this.showFeesTaskRequestDataModal(i, this.showGeneralUserDetails, this.generalPersonTaskForm.get('data').value[i].status);
        } else if (task.approvalType === 'Selection of application process request') {
            this.editTabForm = true;
            this.viewApplicationData(task.taskToken, task);
        } else {
            $('#submitTaskRequestDataModal').modal('show');
        }
    }



    getPersonFeesRequestObject(i, table, task) {
        this.link = task.link;
        this.requestType = task.approvalType;
        this.table = table;
        if (table === 'GeneralTask') {
            this.id = this.showGeneralUserDetails.applicationId;
            this.status = this.generalPersonTaskForm.value.data[i].status;
        }
        $('#submitTaskRequestDataModal').modal('show');

    }



    public getTrainerData() {
        this.spinner.show();
        this.userService.getTrainerService(this.token).subscribe((data: any) => {
            this.spinner.hide();
            if (data.status === true) {
                console.log(data.trainerList);
                this.trainerList = data.trainerList;
                this.createFormForTrainerList();
            } else {
                this.toastr.error(data.message);
            }
        });
    }

    createFormForTrainerList() {
        setTimeout(() => {
            $('.selectpicker').selectpicker('refresh');
        }, 50);

        this.trainerFormGroup = this.formBuilder.group({
            trainerId: [null, Validators.required],
            trainerName: [null, Validators.required],
            status: [this.status],
        });
    }

    public onSetTrainerValue(e): void {
        let find = this.trainerList.filter(x => x.trainerName === e.target.value)[0];
        this.trainerFormGroup.get('trainerId').setValue(find.trainerId);
        this.trainerFormGroup.get('trainerName').setValue(find.trainerName);
    }

    showFeesTaskRequestDataModal(index, applicantData, type) {
        this.spinner.show();
        this.userService.selectFeesDataForPersonService(this.token, applicantData.id).subscribe((data: any) => {
            this.spinner.hide();
            if (data.status === true) {
                this.showApplicantUserDetails = applicantData;
                this.createFormForLicensingApplicationFees(data);
                if (type == "Rejected") {
                    this.isEdit = false;
                }
                this.selectLicenceFeesForLicensingApplication = data.data;
                $('#submitTaskRequestAndPersonFeesDataModal').modal('show');

            } else {
                this.toastr.error(data.message);
            }
        });
    }

    showTaskRequestDataModal() {
        $('#duplicationInformationModal').modal('hide');
        $('#submitTaskRequestDataModal').modal('show');
    }

    postTaskRequest() {
        this.notificationForm.value.applicationId = this.id;
        this.notificationForm.value.status = this.status;
        if (this.notificationForm.value.status === 'true') {
            this.notificationForm.value.isApproved = true;
        } else {
            this.notificationForm.value.isApproved = false;
        }
        if (this.taskStatus === 'On hold') {
            this.notificationForm.value.isOnHold = true;
        } else {
            this.notificationForm.value.isOnHold = false;
        }
        if (this.requestType === 'New medical request' || this.requestType === 'Renew medical request') {
            this.submitted = true;
            if (this.notificationForm.value.isConcussionBaseLineUpToDate === '' || this.notificationForm.value.isConcussionBaseLineUpToDate === null) {
                return;
            }
            this.loading = true;
            if (this.notificationForm.value.isConcussionBaseLineUpToDate === 'Yes') {
                this.notificationForm.value.isConcussionBaseLineUpToDate = true;
            } else {
                this.notificationForm.value.isConcussionBaseLineUpToDate = false;
            }
        }
        if (this.requestType === 'New HRI account request') {
            this.submitted = true;
            this.loading = true;
            this.notificationForm.value.personId = this.personId;
        }
        if (this.person.role === 'Accounts') {
            if (this.requestType === 'Charge fees request') {
                this.notificationForm.value.personId = this.showGeneralUserDetails.id;
            }
            if (this.notificationForm.get('journalVoucherNumber').invalid) {
                return;
            }
        }
        this.spinner.show();
        this.userService.doTaskService(this.token, this.link, this.notificationForm.value).subscribe((data: any) => {
            if (data.status === true) {
                this.toastr.success(data.message);
                if (this.table === 'ApplicationTask') {
                    this.showUserTask(this.showApplicantUserDetails);
                } else if (this.table === 'GeneralTask') {
                    this.viewGeneralDataByPerson(this.showGeneralUserDetails);
                } else if (this.table === 'OtherTask') {
                    this.getOtherTasksList();
                }
            } else {
                this.toastr.error(data.message);
                this.spinner.hide();
            }
            this.notificationForm.reset();
            $('#submitTaskRequestDataModal').modal('hide');
            $('#medicalDetailsModal').modal('hide');
        }, error => {
            if (error.status === 200) {
                return;
            } else {
                this.toastr.error(error.message);
            }
            this.spinner.hide();
        });
    }

    public postTrainerApplicationTabTaskRequest() {
        this.applicationTabFormGroup.value.applicationId = this.showApplicantUserDetails.applicationId;
        this.applicationTabFormGroup.value.status = "Approved";
        if (this.requestType === 'Selection of application process request') {
            this.submitted = true;
            this.loading = true;
        }
        this.spinner.show();
        this.userService.doTaskService(this.token, this.link, this.applicationTabFormGroup.value).subscribe((data: any) => {
            this.spinner.hide();
            this.hideTrainerFirstTimeModal();
            if (data.status === true) {
                this.toastr.success(data.message);
                if (this.table === 'ApplicationTask') {
                    this.showUserTask(this.showApplicantUserDetails);
                }
            } else {
                this.toastr.error(data.message);
            }
        }, error => {
            if (error.status === 200) {
                return;
            } else {
                this.toastr.error(error.message);
            }

        });
    }

    public postTrainerRegisterTaskRequest() {
        if (this.requestType === 'Trainer register request') {
            this.submitted = true;
            this.loading = true;
        }
        this.submitted = true;
        if (this.trainerFormGroup.invalid) {
            return;
        }
        this.spinner.show();
        this.userService.doTaskService(this.token, this.link, this.trainerFormGroup.value).subscribe((data: any) => {
            this.spinner.hide();
            $('#trainerRegisterModal').modal('hide');
            if (data.status === true) {
                this.toastr.success(data.message);
                if (this.table === 'GeneralTask') {
                    this.viewGeneralDataByPerson(this.showGeneralUserDetails);
                }
            } else {
                this.toastr.error(data.message);
            }
        }, error => {
            if (error.status === 200) {
                return;
            } else {
                this.toastr.error(error.message);
            }

        });
    }


    hideTaskRequestData() {
        this.notificationForm.reset();
        if (this.requestMedicalQuestionnaire === true) {
            this.requestMedicalQuestionnaire = false;
            this.licencingDeptBased();
        }
        $('#submitTaskRequestDataModal').modal('hide');
    }

    postSelectLicenceFeesRequest() {
        this.spinner.show();
        const fromData = this.licenceFeesListForm.value;
        this.userService.doSelectLicenceFeesDataForUserLicensingApplicationTaskService(this.token, this.link, fromData).subscribe((data: any) => {
            this.spinner.hide();
            if (data.status === true) {
                this.toastr.success(data.message);
                this.showUserTask(this.showApplicantUserDetails);
            } else {
                this.toastr.error(data.message);
            }
            $('#cancleMoreLicenceFeesRequestModal').modal('hide');
            $('#submitTaskRequestAndLicenceFeesDataModal').modal('hide');
        }, error => {
            if (error.status === 200) {
                return;
            } else {
                this.toastr.error(error.message);
            }
            this.spinner.hide();
        });

    }

    postSelectFeesRequest() {
        this.spinner.show();
        const fromData = this.licenceFeesListForm.value;
        this.userService.doSelectFeesForUserTaskService(this.token, this.link, fromData).subscribe((data: any) => {
            this.spinner.hide();
            if (data.status === true) {
                this.toastr.success(data.message);
                this.isEdit = true;
                $('#submitTaskRequestAndPersonFeesDataModal').modal('hide');
                this.viewGeneralDataByPerson(this.showGeneralUserDetails);
            } else {
                this.toastr.error(data.message);
            }
        }, error => {
            if (error.status === 200) {
                return;
            } else {
                this.toastr.error(error.message);
            }
            this.spinner.hide();
        });

    }


    hideSelectLicenceFeesRequestData() {
        this.licenceFeesListForm.reset();
        $('#submitTaskRequestAndLicenceFeesDataModal').modal('hide');
        $('#submitTaskRequestAndPersonFeesDataModal').modal('hide');
    }

    hideApplicationRequest() {
        this.page3 = 1;
        this.perPage3 = 10;
        this.key3 = 'createdDate';
        this.reverse3 = false;
        this.direction3 = 'DESC';
        this.filterLetter3 = '';
        $('#applicationRequestListModel').modal('hide');
        this.licencingDeptBased();
    }


    viewGeneralDataByPerson(showGeneralUserDetails) {
        this.spinner.show();
        this.showGeneralUserDetails = showGeneralUserDetails;
        this.generalPersonId = showGeneralUserDetails.id;
        this.userService.getTaskByPersonService(this.token, this.generalPersonId, this.page4, this.perPage4, this.key4, this.direction4, this.filterLetter4, this.generalPersonStatus, this.applicantStatusForGeneralTask).subscribe((data: any) => {
            this.spinner.hide();
            this.generalPersonTaskList = data;
            $('#personGeneralRequestListModal').modal({
                backdrop: 'static',
                keyboard: false
            });
            if (data.status === true) {
                this.createFormGeneralDataByPerson(data);
                this.configData4(data);
            }
        }, error => {
            if (error.status === 200) {
                return;
            } else {
                this.toastr.error(error.message);
            }
            this.spinner.hide();
        });
    }


    selectGeneralPersonStatus(event) {
        this.generalPersonStatus = event.target.value;
        this.page4 = 1;
        this.viewGeneralDataByPerson(this.showGeneralUserDetails);
    }

    get generalDataByPersonFormGroup() {
        return this.generalPersonTaskForm.get('data') as FormArray;
    }

    createFormGeneralDataByPerson(data) {
        this.generalPersonTaskForm = this.formBuilder.group({
            data: this.formBuilder.array([])
        });
        this.patchGeneralDataByPerson(data);
    }

    patchGeneralDataByPerson(data) {
        const control = <FormArray>this.generalPersonTaskForm.get('data');
        data.tasks.content.forEach(x => {
            control.push(this.patchValuesGeneralDataByPerson(x));
        });
    }

    patchValuesGeneralDataByPerson(x) {
        return this.formBuilder.group({
            task: [x],
            status: ['', Validators.required],
        })
    }

    filterLetterData4(filterLetter) {
        this.filterLetter4 = filterLetter;
        if (filterLetter.length > 2 || filterLetter.length === 0) {
            this.page4 = 1;
            this.viewGeneralDataByPerson(this.showGeneralUserDetails);
        }
    }

    configData4(data) {
        data = data.tasks;
        this.config4 = {
            id: 'generalTask',
            itemsPerPage: data.pageable.pageSize,
            currentPage: data.pageable.pageNumber + 1,
            totalItems: data.totalElements,
            totalPage: data.totalPages,
            startElement: data.pageable.pageNumber * data.pageable.pageSize + 1,
            endElement: data.pageable.pageNumber * data.pageable.pageSize + data.numberOfElements
        };
    }

    setItemsPerPage4(event) {
        this.perPage4 = event.target.value;
        this.page4 = 1;
        this.viewGeneralDataByPerson(this.showGeneralUserDetails);
    }

    pageChanged4(event, itemsPerPage) {
        this.page4 = event;
        this.perPage4 = itemsPerPage;
        setTimeout(() => {
            this.config4.currentPage = event;
            this.viewGeneralDataByPerson(this.showGeneralUserDetails);
        });
    }

    sort4(key) {
        this.key4 = key;
        this.perPage4 = this.config4.itemsPerPage;
        this.reverse4 = !this.reverse4;
        if (this.reverse4 === false) {
            this.direction4 = 'ASC';
        } else {
            this.direction4 = 'DESC';
        }
        this.viewGeneralDataByPerson(this.showGeneralUserDetails);
    }

    hideGeneralRequest() {
        this.page4 = 1;
        this.perPage4 = 10;
        this.key4 = 'createdDate';
        this.reverse4 = false;
        this.direction4 = 'DESC';
        this.filterLetter4 = '';
        $('#personGeneralRequestListModal').modal('hide');
        this.getGeneralTasks();
    }


    getOtherTasksListSearch() {
        this.personListSearch5.pipe(debounceTime(300),
            switchMap((term: string) => {
                this.isOtherTaskLoading=true
                this.spinner.show('otherTaskLoader');
                return this.userService.getOtherTasksListService(this.token, this.page6, this.perPage6, this.key6, this.direction6, this.filterLetter6);
            })).subscribe((data: any) => {
                this.spinner.hide('otherTaskLoader');
                this.isOtherTaskLoading=false
                this.otherTaskList = data;
                if (data.status === true) {
                    this.createFormOtherTasks(data);
                    this.configData6(data);
                }
            }, error => {
                if (error.status === 200) {
                    return;
                } else {
                    this.toastr.error(error.message);
                }
                this.spinner.hide('otherTaskLoader');
                this.isOtherTaskLoading=false
            });

        this.personListSearch5.next('');
    }


    getOtherTasksList() {
        this.spinner.show();
        if (this.key6.length > 3) {
            this.userService.getOtherTasksListService(this.token, this.page6, this.perPage6, this.key6, this.direction6, this.filterLetter6).pipe(debounceTime(300)).subscribe((data: any) => {
                this.spinner.hide();
                this.otherTaskList = data;
                if (data.status === true) {
                    this.createFormOtherTasks(data);
                    this.configData6(data);
                }
            }, error => {
                if (error.status === 200) {
                    return;
                } else {
                    this.toastr.error(error.message);
                }
                this.spinner.hide();
            });
        }
    }

    get otherTasksFormGroup() {
        return this.otherTaskForm.get('data') as FormArray;
    }

    createFormOtherTasks(data) {
        this.otherTaskForm = this.formBuilder.group({
            data: this.formBuilder.array([])
        });
        this.patchOtherTasks(data);
    }

    patchOtherTasks(data) {
        const control = <FormArray>this.otherTaskForm.get('data');
        data.tasks.content.forEach(x => {
            control.push(this.patchValuesOtherTasks(x));
        });
    }

    patchValuesOtherTasks(x) {
        return this.formBuilder.group({
            task: [x],
            status: ['', Validators.required],
        })
    }

    filterLetterData6(event) {
        var keycode = event.keyCode || event.which;
        this.filterLetter = event.target.value;
        if (keycode == 13) {
            this.page6 = 1;
            this.personListSearch5.next(event.target.value);
        }
    }

    configData6(data) {
        data = data.tasks;
        this.config6 = {
            id: 'otherTasks',
            itemsPerPage: data.pageable.pageSize,
            currentPage: data.pageable.pageNumber + 1,
            totalItems: data.totalElements,
            totalPage: data.totalPages,
            startElement: data.pageable.pageNumber * data.pageable.pageSize + 1,
            endElement: data.pageable.pageNumber * data.pageable.pageSize + data.numberOfElements
        };
    }

    setItemsPerPage6(event) {
        this.perPage6 = event.target.value;
        this.page6 = 1;
        this.getOtherTasksList();
    }

    pageChanged6(event, itemsPerPage) {
        this.page6 = event;
        this.perPage6 = itemsPerPage;
        setTimeout(() => {
            this.config6.currentPage = event;
            this.getOtherTasksList();
        });
    }

    sort6(key) {
        this.key6 = key;
        this.perPage6 = this.config6.itemsPerPage;
        this.reverse6 = !this.reverse6;
        if (this.reverse6 === false) {
            this.direction6 = 'ASC';
        } else {
            this.direction6 = 'DESC';
        }
        this.getOtherTasksList();
    }

    getWaitingOnOtherTasksList() {
        if (this.key7.length > 3) {
            this.isWaitingOnOtherTaskLoading=true
            this.spinner.show('waitingOtherTaskLoader');
            this.userService.getWaitingOnOtherTasksListService(this.token, this.page7, this.perPage7, this.key7, this.direction7, this.filterLetter7).pipe(debounceTime(300)).subscribe((data: any) => {
                this.spinner.hide('waitingOtherTaskLoader');
                this.isWaitingOnOtherTaskLoading=false
                this.waitingOnOtherTaskList = data;
                if (data.status === true) {
                    this.configData7(data);
                }
            }, error => {
                if (error.status === 200) {
                    return;
                } else {
                    this.toastr.error(error.message);
                }
                this.spinner.hide('waitingOtherTaskLoader');
                this.isWaitingOnOtherTaskLoading=false
            });
        }
    }

    filterLetterData7(filterLetter) {
        this.filterLetter7 = filterLetter;
        if (filterLetter.length > 2 || filterLetter.length === 0) {
            this.page7 = 1;
            this.getWaitingOnOtherTasksList();
        }
    }

    configData7(data) {
        data = data.tasks;
        this.config7 = {
            id: 'waitingOnOtherTasks',
            itemsPerPage: data.pageable.pageSize,
            currentPage: data.pageable.pageNumber + 1,
            totalItems: data.totalElements,
            totalPage: data.totalPages,
            startElement: data.pageable.pageNumber * data.pageable.pageSize + 1,
            endElement: data.pageable.pageNumber * data.pageable.pageSize + data.numberOfElements
        };
    }

    setItemsPerPage7(event) {
        this.perPage7 = event.target.value;
        this.page7 = 1;
        this.getWaitingOnOtherTasksList();
    }

    pageChanged7(event, itemsPerPage) {
        this.page7 = event;
        this.perPage7 = itemsPerPage;
        setTimeout(() => {
            this.config7.currentPage = event;
            this.getWaitingOnOtherTasksList();
        });
    }

    sort7(key) {
        this.key7 = key;
        this.perPage7 = this.config7.itemsPerPage;
        this.reverse7 = !this.reverse7;
        if (this.reverse7 === false) {
            this.direction7 = 'ASC';
        } else {
            this.direction7 = 'DESC';
        }
        this.getWaitingOnOtherTasksList();
    }

    numberOnly(event): boolean {
        const charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        }
        return true;

    }

    getPersonListDataSearch() {
        this.personListSearch4.pipe(debounceTime(300),
            switchMap((term: string) => {
                this.spinner.show();
                return this.userService.getPersonListService(this.token, this.page8, this.perPage8, this.key8, this.direction8, this.filterLetter8);
            })).subscribe((data: any) => {
                this.spinner.hide();
                this.personListData = data;
                if (data.status === true) {
                    this.createFormSuspendAccountList(data);
                    this.configData8(data);
                }
            }, error => {
                if (error.status === 200) {
                    return;
                } else {
                    this.toastr.error(error.message);
                }
                this.spinner.hide();
            });

        this.personListSearch4.next('');
    }



    getPersonListData() {
        this.spinner.show();
        if (this.key8.length > 3) {
            this.userService.getPersonListService(this.token, this.page8, this.perPage8, this.key8, this.direction8, this.filterLetter8).pipe(debounceTime(300)).subscribe((data: any) => {
                this.spinner.hide();
                this.personListData = data;
                if (data.status === true) {
                    this.createFormSuspendAccountList(data);
                    this.configData8(data);
                }
            }, error => {
                if (error.status === 200) {
                    return;
                } else {
                    this.toastr.error(error.message);
                }
                this.spinner.hide();
            });
        }
    }

    get suspendAccountListFormGroup() {
        return this.suspendAccountListForm.get('data') as FormArray;
    }

    createFormSuspendAccountList(data) {
        this.suspendAccountListForm = this.formBuilder.group({
            data: this.formBuilder.array([])
        });
        this.patchSuspendAccountList(data);
    }

    patchSuspendAccountList(data) {
        const control = <FormArray>this.suspendAccountListForm.get('data');
        data.data.content.forEach(x => {
            control.push(this.patchValuesSuspendAccountList(x));
        });
    }

    patchValuesSuspendAccountList(x) {
        return this.formBuilder.group({
            data: [x],
            isAccountSuspended: [x.isAccountSuspended],
        })
    }

    filterLetterData8(filterLetter) {
        this.filterLetter8 = filterLetter;
        if (filterLetter.length > 2 || filterLetter.length === 0) {
            this.page8 = 1;
            this.personListSearch4.next(filterLetter);
        }
    }

    pageChanged8(event, itemsPerPage) {
        this.page8 = event;
        this.perPage8 = itemsPerPage;
        setTimeout(() => {
            this.config8.currentPage = event;
            this.getPersonListData();
        });
    }

    sort8(key) {
        this.key8 = key;
        this.perPage8 = this.config8.itemsPerPage;
        this.reverse8 = !this.reverse8;
        if (this.reverse8 === false) {
            this.direction8 = 'ASC';
        } else {
            this.direction8 = 'DESC';
        }
        this.getPersonListData();
    }

    setItemsPerPage8(event) {
        this.perPage8 = event.target.value;
        this.page8 = 1;
        this.getPersonListData();
    }

    configData8(data) {
        data = data.data;
        this.config8 = {
            id: 'personList',
            itemsPerPage: data.pageable.pageSize,
            currentPage: data.pageable.pageNumber + 1,
            totalItems: data.totalElements,
            totalPage: data.totalPages,
            startElement: data.pageable.pageNumber * data.pageable.pageSize + 1,
            endElement: data.pageable.pageNumber * data.pageable.pageSize + data.numberOfElements
        };
    }

    isSubmitSuspendUserAccount(i, checked, data) {
        this.suspendAccountForm = this.formBuilder.group({
            isActive: [checked],
            id: [data.personId],
            licence: [data.licenceType],
            longName: [data.longName],
        });
        $('#isSuspendUserAccountModal').modal({
            backdrop: 'static',
            keyboard: false
        });
    }

    submitSuspendUserAccount() {
        this.spinner.show();
        this.userService.postSuspendAccountPersonService(this.token, this.suspendAccountForm.value).subscribe((data: any) => {
            this.spinner.hide();
            if (data.status === true) {
                this.isSuspendAccount = false;
                this.toCloseSuspendUserAccount();
                this.toastr.success(data.message);
            } else {
                this.toastr.error(data.message);
            }
        }, error => {
            if (error.status === 200) {
                return;
            } else {
                this.toastr.error(error.message);
            }
            this.spinner.hide();
        });
    }



    downloadEmployeePdf() {
        this.spinner.show();
        this.userService.downloadEmployeePDFService(this.token, this.applicationId).subscribe((data: any) => {
            this.spinner.hide();
            if (data.status === true) {
                this.downloadFile(data.data);
                this.toastr.success(data.message);
            } else {
                this.toastr.error(data.message);
            }
        }, error => {
            if (error.status === 200) {
                return;
            } else {
                this.toastr.error(error.message);
            }
            this.spinner.hide();
        });
    }

    downloadAssistantTrainerPdf() {
        this.spinner.show();
        this.userService.downloadAssistantTrainerPDFService(this.token, this.applicationId).subscribe((data: any) => {
            this.spinner.hide();
            if (data.status === true) {
                this.downloadFile(data.data);
                this.toastr.success(data.message);
            } else {
                this.toastr.error(data.message);
            }
        }, error => {
            if (error.status === 200) {
                return;
            } else {
                this.toastr.error(error.message);
            }
            this.spinner.hide();
        });
    }

    downloadAuthorisedRepresentativePdf() {
        this.spinner.show();
        this.userService.downloadAuthorisedRepresentativePDFService(this.token, this.applicationId).subscribe((data: any) => {
            this.spinner.hide();
            if (data.status === true) {
                this.downloadFile(data.data);
                this.toastr.success(data.message);
            } else {
                this.toastr.error(data.message);
            }
        }, error => {
            if (error.status === 200) {
                return;
            } else {
                this.toastr.error(error.message);
            }
            this.spinner.hide();
        });
    }

    downloadPdf(yardType: String) {
        this.spinner.show();
        this.userService.downloadPrincipalYardPDFService(this.token, this.applicationId, yardType).subscribe((data: any) => {
            this.spinner.hide();
            if (data.status === true) {
                this.downloadFile(data.data);
                this.toastr.success(data.message);
            } else {
                this.toastr.error(data.message);
            }
        }, error => {
            if (error.status === 200) {
                return;
            } else {
                this.toastr.error(error.message);
            }
            this.spinner.hide();
        });
    }
    getCreateMessageService() {
        this.spinner.show();
        this.userService.getCreateMessageServiceService(this.token, this.applicationId).subscribe((data: any) => {
            this.spinner.hide();
            if (data.status === true) {

                window.open(data.data, "_blank");

                this.toastr.success(data.message);
            } else {
                this.toastr.error(data.message);
            }
        }, error => {
            if (error.status === 200) {
                return;
            } else {
                this.toastr.error(error.message);
            }
            this.spinner.hide();
        });
    }
    proceedSendToAccountsModal(personId) {
        this.personId = personId;
        $('#proceedSendToAccountsModal').modal({
            backdrop: 'static',
            keyboard: false
        });
    }

    onLicensingApplicationTypeSelected(event: any, personId) {
        this.spinner.show();
        const data = { personId: personId, licenceType: event.target.value };
        this.userService.getUserApplicationForLicensingDepartmentService(this.token, data).subscribe((data: any) => {
            this.spinner.hide();
            if (data.status === true) {
                this.licencingDeptBased();
            }
        }, error => {
            this.spinner.hide();
            if (error.status === 200) {
                return;
            } else {
                this.toastr.error(error.message);
            }
        });
    }

    submitForSendToAccountsModal() {
        this.spinner.show();
        const data = { personId: this.personId }
        this.userService.postSendToAccountsService(this.token, data).subscribe((data: any) => {
            this.spinner.hide();
            $('#proceedSendToAccountsModal').modal('hide');
            if (data.status === true) {
                this.proceedIssueLicenceDataSuccessMessage = data.message;
                // $('#proceedIssueLicenceSuccessModel').modal({
                //     backdrop: 'static',
                //     keyboard: false
                // });
                this.toastr.success(data.message);
                this.getGeneralTasks();
            } else {
                this.toastr.error(data.message);
            }
        }, error => {
            this.spinner.hide();
            if (error.status === 200) {
                return;
            } else {
                this.toastr.error(error.message);
            }
        });


    }

    toCloseProceedSendToAccountsModal() {
        $('#proceedSendToAccountsModal').modal('hide');
    }


    getExpiredLicence(email) {
        this.spinner.show();
        this.userService.getExpiredLicenceService(this.token, email).subscribe((data: any) => {
            this.spinner.hide();
            if (data.status === true) {
                this.downloadFile(data.data);
                this.toastr.success(data.message);
            } else {
                this.toastr.error(data.message);
            }
        }, error => {
            if (error.status === 200) {
                return;
            } else {
                this.toastr.error(error.message);
            }
            this.spinner.hide();
        });
    }

    toCloseSuspendUserAccount() {
        this.suspendAccountForm.reset();
        this.getPersonListData();
        $('#isSuspendUserAccountModal').modal('hide');
    }

    hideUserLicenceDetails() {
        $('#userLicenceDetailsModal').modal('hide');
    }

    hideUserReferenceRequest() {
        $('#userReferenceDetailsModal').modal('hide');
    }

    hideApplicationSummaryDetails() {
        $('#viewApplicantSummaryDetailsModal').modal('hide');
    }

    hideSummaryFileUpload() {
        $('#summaryFileUploadModal').modal('hide');
    }

    hideEducationHistoryDetails() {
        $('#educationHistoryDetailsModal').modal('hide');
    }

    hideEmergencyLicenceDetailsData() {
        $('#emergencyLicenceDetailsDataModal').modal('hide');
    }

    hideLicensingApplicationDetails() {
        $('#licensingApplicationDetailsModal').modal('hide');
    }

    hideJockeyAgentApplicationDetails() {
        $('#jockeyAgentApplicationDetailsModal').modal('hide');
    }

    hideMedicalQuestionDetails() {
        $('#medicalDetailsModal').modal('hide');
    }

    hideJockeyValetDetails() {
        $('#jockeyValetApplicationDetailsModel').modal('hide');
    }

    hideDuplicationInformation() {
        $('#duplicationInformationModal').modal('hide');
    }

    toCloseLicenceFeesModal() {
        $('#viewLicenceFeesModel').modal('hide');
    }

    hideTrainerFirstTimeModal() {
        this.editTabForm = false;
        this.applicationTabFormGroup.reset();
        $('#trainerFirstTimeModal').modal('hide');
    }

    ngOnDestroy() {
        $('#applicationRequestListModel').modal('hide');
        $('#personGeneralRequestListModal').modal('hide');
        $('#userDetailsModal').modal('hide');
        $('#userLicenceDetailsModal').modal('hide');
        $('#userReferenceDetailsModal').modal('hide');
        $('#viewApplicantSummaryDetailsModal').modal('hide');
        $('#summaryFileUploadModal').modal('hide');
        $('#medicalDetailsModal').modal('hide');
        $('#licensingApplicationDetailsModal').modal('hide');
        $('#jockeyAgentApplicationDetailsModal').modal('hide');
        $('#jockeyValetApplicationDetailsModel').modal('hide');
        $('#submitTaskRequestDataModal').modal('hide');
        $('#committeeMeetingReviewModal').modal('hide');
        $('#committeeMeetingReviewSuccessModel').modal('hide');
        $('#proceedIssueLicenceModal').modal('hide');
        $('#proceedIssueLicenceSuccessModel').modal('hide');
        $('#emergencyLicenceDetailsDataModal').modal('hide');
        $('#isSuspendUserAccountModal').modal('hide');
        $('#postClaimOrAssignDataModel').modal('hide');
        $('#duplicationInformationModal').modal('hide');
        $('#viewLicenceFeesModel').modal('hide');
        $('#trainerFirstTimeModal').modal('hide');
    }
}